import { DemandOrder } from '@/modules/productionModule/models/demandOrders'

const demandOrdersRoute = createApiRoute(ApiModule.DEMAND_PLANNING, ApiDataModel.DEMAND_ORDERS)

const buildDemandOrderQuery = (params: IFetchDemandOrdersParams) => {
	const pagination =
		params.page || params.perPage ? { page: params.page ?? 1, perPage: params.perPage ?? DEFAULT_PAGE_SIZE } : null

	return createQuery(pagination, null, undefined, {
		date: params.date,
		order_type: params.orderType,
		assigned: params.assigned,
	})
}

export const apiDemandOrders = {
	fetchDemandOrders: async (params: IFetchDemandOrdersParams): Promise<IApiResponseModel<IDemandOrderModel[]>> => {
		const { data, meta } = await apiCommon<IDemandOrder[]>(demandOrdersRoute, {
			method: 'GET',
			...buildDemandOrderQuery(params),
		})

		return {
			data: data ? data.map(DemandOrder) : [],
			meta,
		}
	},

	assignDemandOrderFacility: async (demandOrderId: string, facilityId: string): Promise<void> => {
		await apiCommon(`${demandOrdersRoute}/${demandOrderId}/facility`, {
			method: 'PUT',
			body: { facility_id: facilityId },
		})
	},

	unassignDemandOrderFacility: async (demandOrderId: string): Promise<void> => {
		await apiCommon(`${demandOrdersRoute}/${demandOrderId}/facility`, {
			method: 'DELETE',
		})
	},
}
